import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'

import webrtc from './modules/webrtc'
import tagsView from './modules/tagsView'
import caseInfoPage from './modules/caseInfoPage'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    webrtc,
    tagsView,
    caseInfoPage
  },
  getters,
  plugins: [
    createPersistedstate({
      storage: window.sessionStorage,
      key: 'caseInfoPage',
      paths: ['caseInfoPage']
    })
  ]
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js